<template>
  <v-card
    class="asset-card"
    :class="[{ 'asset-card--catalogue-selected': catalogueSelected }]"
    width="100%"
    hover
    :style="{ minHeight: minHeight + 'px' }"
  >
    <v-container
      @click="
        catalogueListing
          ? assetClicked()
          : $router.push('/asset/' + asset.detailid)
      "
      class="pa-2"
    >
      <div class="asset-card__media">
        <a :href="asseturl" v-if="isUrlLink">
          <v-img
            contain
            :src="
              asset.thmUrl != null
                ? asset.thmUrl + sasToken
                : 'https://activstoredev.blob.core.windows.net/test/box.png'
            "
            :style="'height:' + imageHeight + 'px;width:100%'"
          />
        </a>
        <v-img
          v-else
          contain
          :src="
            asset.thmUrl != null
              ? asset.thmUrl + sasToken
              : 'https://activstoredev.blob.core.windows.net/test/box.png'
          "
          :style="'height:' + imageHeight + 'px;width:100%'"
        />

        <div v-if="showSelect || showDelete" class="asset-card__overlay">
          <div class="asset-card__overlay-left" @click.stop>
            <div v-if="showSelect" class="asset-card__control-badge">
              <v-checkbox
                hide-details
                v-model="assetCheckBox"
                dense
                class="ma-0 pa-0 asset-card__checkbox"
                @change="assetSelected(asset.id)"
              />
            </div>
          </div>
          <div class="asset-card__overlay-right" @click.stop>
            <v-btn
              v-if="showDelete"
              icon
              color="red"
              class="ma-0"
              small
              @click="$emit('onDelete', asset)"
            >
              <v-icon>mdi-close-circle</v-icon>
            </v-btn>
          </div>
        </div>
      </div>

      <v-card-text class="asset-card__text px-2 pt-2 pb-0">
        <div class="asset-card__name">
          {{ asset.name }}
        </div>
        <div
          v-if="asset.identifier != asset.name"
          class="asset-card__identifier"
        >
          {{ asset.identifier }}
        </div>
      </v-card-text>
    </v-container>
  </v-card>
</template>

<script>
import { mapState, mapGetters } from "vuex";

export default {
  name: "AssetCard",
  props: {
    //The asset model to use for this card
    asset: {
      default: {},
      type: Object,
    },
    //Should this asset be selectable?
    showSelect: {
      default: false,
      type: Boolean,
    },
    //Is this a catalogue listing?
    catalogueListing: {
      default: false,
      type: Boolean,
    },
    //Is this selected in the catalogue page?
    catalogueSelected: {
      default: false,
      type: Boolean,
    },
    //Should the card be a url link?
    isUrlLink: {
      default: false,
      type: Boolean,
    },
    //Min height of card
    minHeight: {
      default: 275,
      type: Number,
    },
    //Height of image within card
    imageHeight: {
      default: 160,
      type: Number,
    },
    //Show the deletion option
    showDelete: {
      default: false,
      type: Boolean,
    },
    //Force selection of this card.
    selected: {
      default: false,
      type: Boolean,
    },
  },
  computed: {
    ...mapGetters("authentication", ["sasToken"]),

    asseturl() {
      return window.location.origin + "/#/asset/" + this.asset.detailid;
    },
  },
  data: () => ({
    assetCheckBox: false,
  }),
  methods: {
    assetSelected(id) {
      this.$emit("AssetSelected", { id: id, value: this.assetCheckBox });
    },
    assetClicked() {
      this.$emit("AssetClicked", this.asset);
    },
  },
  watch: {
    selected: {
      immediate: true,
      handler(isSelected) {
        this.assetCheckBox = isSelected;
      },
    },
  },
};
</script>

<style lang="scss">
@use "@/styles/AssetCard.scss";
</style>
